<template>
  <div>
    <div class="section">
      <div class="container">
        <div class="section__content center login">
          <form v-on:submit.prevent="login">
            <h1 class="std__subtile">{{$t("login_title")}}</h1>
            <h2 class="std__subtile md">
              {{$t("confirmation")}}
            </h2>
            <div class="formElm">
              <input
                type="tel"
                class="formElm__input"
                v-model="msisdn"
                maxlength="14"
                placeholder
              />
            </div>
            <div class="formElm">
              <button type="submit" class="btn btn-lg stdBtn">{{$t("submit")}}</button>
            </div>
            <div
              v-if="showStatusAlert"
              class="alert alert-danger col-md-3"
              role="alert"
            >
              <span v-if="language ==='english'">{{ status }}</span>
              <span v-if="language !=='english'">{{ statusTran }}</span>
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
            <div
              v-if="showMsisdnAlert"
              class="alert alert-danger col-md-5"
              role="alert"
            >
              {{$t("valid_number")}}
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import mobiscope from "../../../router/mobiscope";
import country_list from "../../../locales/country_list.json";
import EventBus from "../../EventBus.vue";
import { mapGetters,mapActions } from "vuex";
import mobiscopeAPI from "../../../services/api/mobiscopeAPI"

var TJO = require("translate-json-object")();

const proxyurl = "https://corsanywhere.herokuapp.com/"; //prevent CORS

export default {
  data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false
    };
  },created(){
    this.getPrefix(this.countryCode)
  },
  computed: mapGetters(["language", "translateCode", "gcid_mobis", "countryCode"]),
  methods: {
    getPrefix(countryCode){
      if(countryCode =='cz'){
        this.msisdn = '+420';
      }
      if(countryCode =='no'){
        this.msisdn = '+47';
      }
      if(countryCode =='bg'){
        this.msisdn = '+359';
      }
    },
    close(){
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login() {
      let regex = /^\d{9,}$/;
      if(this.countryCode =='cz'){
        let a = this.msisdn;
        this.msisdn = a.replace("+","");
      }
      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if(regex.test(this.msisdn) == false){
          this.showMsisdnAlert = true;
        }else{
          let gcid = "";
          
          if(this.gcid_mobis != ""){
            gcid = this.gcid_mobis;
          }else{
            gcid = "264";
          }

          let data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

        const login = {
          url: `${proxyurl}`+`http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=${data.msisdn}&gcid=${data.gcid}&verbose=${data.verbose}`,
          method: "POST"
        };

          this.$axios(login).then(res =>{
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("tokenID",  res.data.contents);
              localStorage.setItem("userTokenID_mobis", response.token);
              localStorage.setItem("userProfile_mobis", res.data.contents);
              localStorage.setItem("mobis_msisdn", response.msisdn);
              localStorage.setItem("mobis_country_code", response.country_code);
              localStorage.setItem("mobis_gateway_code", response.gateway_code);
              localStorage.setItem("mobis_subscription_date", response.subscription_date);
              this.msisdn = "";
              this.login_mobis("loggedin");
              mobiscope.push({ name: "Horoscope" }).catch(err => {});
              // location.reload();
            } else if (response.status == "inactive") {
              this.showStatusAlert = true;
              this.showMsisdnAlert = false;
              let status = response.status.replace( response.status.toUpperCase());
              this.status = status;

              for (let [key, value] of Object.entries(country_list)) {
                if(this.countryCode == key){
                  let status_lang = require(`../../../locales/mobiscope/${value.language}.json`);
                  this.statusTran = status_lang.status;
                }
              }
            }
          })
          .catch(err => 
            console.log(err)
          )
        }
      }
    },
    ...mapActions(["login_mobis"]),
    emitMethod() {
      EventBus.$emit("logged-in", "loggedin");
    }
  }
};
</script>

<style lang="scss">
.section__content.login {
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
}

.formElm {
  position: relative;
  max-width: 320px;
  width: 100%;
  margin: 15px auto;
  input {
    appearance: none;
    outline: none;
    padding: 15px;
    width: 100%;
    border-radius: 25px;
    font-size: 1.3rem;
    font-weight: 600;
    background: #fff;
    border: 0;
    margin: 0px;
  }
  button {
    width: 100%;
    border-radius: 25px;
    padding: 15px;
    font-size: 1.3rem !important;
  }
}

.alert{
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/mobiscope/Login.vue